import {IBaseLookup} from "./Ibase.lookup";

export namespace AssigningAuthority {

    export const lookupName: string = "AssigningAuthority";

    export interface AssigningAuthority {
        assigningAuthorityKey: number;
        namespace: string;
        universalId: string;
        universalIdType: string;
        active: string;
        displayName: string;
        lastUpdated: Date;
    }

    export interface AssigningAuthorityDS extends IBaseLookup {
        assigningAuthority: AssigningAuthority[];
    }
}
